import {
    postAuthPlatformAuthorizeV01Reducer,
} from '../../slices/gq-admin/auth';

export const gqAdminAuthReducers = {
    postAuthPlatformAuthorizeV01: postAuthPlatformAuthorizeV01Reducer,
};
